import React from 'react';

import CSS from './styles.css';
import SortByMenu from './SortByMenu';
import FilterByMenu from './FilterByMenu';
import Button from 'Shared/Button';


const FilterBarViews = ({ isMobile, currentParentIndex, goToNextMenu, goToNextMenuFromSubmenu, openFilterPanel, updateParentIndex }) => {
  return (
    <nav className={ CSS['container'] }>
      <ul role="filterbar" aria-label="functions" className={ CSS['header'] }>
        <SortByMenu goToNextMenu={ goToNextMenu } goToNextMenuFromSubmenu={ goToNextMenuFromSubmenu } currentParentIndex={ currentParentIndex } updateParentIndex={ updateParentIndex }/>

        {!isMobile
          ? <FilterByMenu goToNextMenu={ goToNextMenu } goToNextMenuFromSubmenu={ goToNextMenuFromSubmenu } currentParentIndex={ currentParentIndex } updateParentIndex={ updateParentIndex }/>
          : <Button  className={ CSS['filter-button'] } label="Filter" onClick={ openFilterPanel } />
        }
      </ul>
    </nav>
  );
}


export default FilterBarViews;
